/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetPatientExerciseSchema } from '../models/GetPatientExerciseSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PatientPatientExercisesApi {
    /**
     * Api Patch Done At
     * Patient has finished his exercises.
     * @returns GetPatientExerciseSchema Created
     * @throws ApiError
     */
    public static patientExercisesApiPatchDoneAtPatch({
        patientExerciseId,
    }: {
        patientExerciseId: string,
    }): CancelablePromise<GetPatientExerciseSchema> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/patient-exercises/patient/{patient_exercise_id}/done_at/',
            path: {
                'patient_exercise_id': patientExerciseId,
            },
        });
    }
}
